import {
	IPayloadSockets,
	IQuestionResultAction,
	ISetWagerAction,
	ITriviaFooter,
	ITriviaGame,
	ITriviaQuestion,
	IUserAnswer
} from 'modules/reducers/trivia';
import {EnumAfterRoundState, EnumInGameState, EnumTriviaStatesOfGame} from 'modules/utils/enums';
import {createAction} from 'redux-act';
import {AnswerEventTypes} from 'modules/types';


export const fetchGameJSONS = createAction('fetchGameJSONS');
export const fetchGameJSONSSuccess = createAction('fetchGameJSONSSuccess');
export const checkGameState = createAction('checkGameState');
export const loungeScreen = createAction('loungeScreen');
export const voidEvent = createAction('voidEvent');
export const changeStateOfGame = createAction<EnumTriviaStatesOfGame>('changeStateOfGame');
export const changeStateInGame = createAction<EnumInGameState>('changeStateInGame');
export const establishConnection = createAction('establishConnection');

export const startTrivia = createAction<IPayloadSockets>('startTrivia');
export const gotAnswerEvent = createAction<AnswerEventTypes | AnswerEventTypes[]>('startTrivia');
export const questionsAnswered = createAction('questionsAnswered');
export const removeAnswerEvent = createAction<number>('removeAnswerEvent');
export const questionEnd = createAction('questionEnd');
export const questionShown = createAction('questionShown');
export const animationEnd = createAction('animationEnd');


/**
 * Warning Card
 */
export const warningFinished = createAction('warningFinished');

/**
 * Questions Card
 */
export const showQuestion = createAction<ITriviaQuestion>('showQuestion');
export const showSetQuestions = createAction<ITriviaGame['display_set_questions']>('showSetQuestions');
export const recordQuestion = createAction<ITriviaQuestion>('recordQuestion');
export const recordQuestions = createAction<ITriviaGame['questions']>('recordQuestions');
export const clearQuestions = createAction('clearQuestions');
export const questionTimeEnd = createAction('questionTimeEnd');

/**
 * Answers
 */
export const makeAnswer = createAction<IUserAnswer>('makeAnswer');
export const setQuestionResult = createAction<IQuestionResultAction>('setQuestionResult');
export const setQuestionsResults = createAction<ITriviaGame['questions_result']>('setQuestionBEResults');

/**
 * Points badge
 */
export const showPoints = createAction('showPoints');
export const hidePoints = createAction('hidePoints');
export const showPointsWager = createAction('showPointsWager');
export const hidePointsWager = createAction('hidePointsWager');

export const runPractice = createAction('runPractice');
export const runTest = createAction('runTest');

export const setTriviaFooterState = createAction<Partial<ITriviaFooter>>('setTriviaFooterState')

/**
 * To debugging.
 */
export const debugTriviaQuestion = createAction<number>('debugTriviaQuestion');
export const debugTriviaRound = createAction<number>('debugTriviaRound');

export interface IDebugContest {
	id: number,
	type: 'night' | 'daily' | string
}

export const debugTriviaContest = createAction<IDebugContest>('debugTriviaContest');

/**
 * Only applies for round break state and for wager round
 */
export const changeStateAfterRound = createAction<EnumAfterRoundState>('changeStateAfterRound');

export const setWager = createAction<ISetWagerAction>();
export const getWager = createAction<ISetWagerAction['round_id']>();
export const setRoundStatusAction = createAction<any>();
export const getWagerSuccess = createAction<Omit<ITriviaGame['wager'], 'is_fetched'>>();

/*
 Perfect round modal actions
 */
export const showPerfectModal = createAction('showPerfectModal');
export const hidePerfectModal = createAction('hidePerfectModal');

export const showBonusPointsSwipeIt = createAction('showBonusPointsSwipeIt');
export const hideBonusPointsSwipeIt = createAction('hideBonusPointsSwipeIt');
export const setBonusPoints = createAction<number>('setBonusPoints');
